import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { Image } from 'mui-image' // @see : https://www.npmjs.com/package/mui-image

import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';

import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';

import CloseIcon from '@mui/icons-material/Close';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

const ColisLogistiquePhoto = ({ colis, label, disabledMessage, mode, iconSize }) => {

    const [open, setOpen] = React.useState(false);
    const [fullScreen, setFullScreen] = React.useState(false);

    const [src, setSrc] = React.useState(null);
    const [error, setError] = React.useState("");


    React.useEffect(() => {

        const fetchData = async () => {

            await axios("/api/preparation-logistique-photo/" + colis.photoId, { responseType: "blob" })
                .then(function (response) {

                    //console.log("response", response);
                    //console.log("response.headers['content-type']", response.headers['content-type']);
                    //console.log("response.data", response.data);

                    const source = URL.createObjectURL(response.data);

                    setSrc(source);

                })
                .catch(function (error) {
                    console.log(error);
                    setError("Impossible d'afficher l'image");
                })
                .then(function () {
                    // always executed
                    //setLoading(false);
                });
        };

        if (colis.photoId && open && !src && !disabledMessage) {
            fetchData();
        }
    }, [colis, open, src]);




    const handleClose = (event, reason) => {
        event.stopPropagation();
        if (reason !== "backdropClick") {
            setOpen(false);
            setFullScreen(false);
        }
    };

    const toggleFullScreen = () => {
        setFullScreen(!fullScreen);
    }


    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}>   

            {mode === 'button' && (


                <Tooltip title={disabledMessage !== '' ? disabledMessage : ''} disableInteractive>
                    <span>
                        <Button
                            sx={{ marginRight: '8px' }}
                            variant="outlined"
                            color={disabledMessage !== '' ? "primary" : "secondary" }
                            startIcon={colis.photoId ? <PhotoCameraIcon size={iconSize} /> : <NoPhotographyIcon size={iconSize} />}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (disabledMessage === '') {
                                    setOpen(true);
                                }
                            }}
                            disabled={disabledMessage !== ''}
                        >
                            {colis.numeroSupport}
                        </Button>
                    </span>
                </Tooltip>
                
            )}


            {mode === 'icon' && (

                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        if (disabledMessage === '') {
                            setOpen(true);
                        }
                    }}
                    size={iconSize}

                    disabled={disabledMessage !== ''}
                >

                    {colis.photoId && (
                        <PhotoCameraIcon />
                    )}

                    {!colis.photoId && (
                        <NoPhotographyIcon />
                    )}
                </IconButton>

            )}


            <Dialog
                open={open}
                fullScreen={fullScreen}
                onClose={handleClose}
                scroll={"paper"}
            >
                <DialogTitle>

                    <Stack direction='row'>
                        <Stack sx={{ flexGrow: 1 }}>
                            {label ? label : colis.numeroSupport}
                        </Stack>
                        <IconButton
                            onClick={toggleFullScreen}
                            size={iconSize}
                        >
                            {!fullScreen && (<ZoomOutMapIcon />)}
                            {fullScreen && (<ZoomInMapIcon />)}                            
                        </IconButton>
                        <IconButton
                            onClick={handleClose}
                            size={iconSize}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>

                </DialogTitle>

                <DialogContent>
                    {src && (
                        <Image src={src} fit={ "contain" } />
                    )}

                    {!src && !error && (
                        <Skeleton />
                    )}

                    {error && (
                        <span>{error}</span>
                    )}
                </DialogContent>             

            </Dialog>

        </div>
    );
};

ColisLogistiquePhoto.propTypes = {
    colis: PropTypes.object.isRequired,
    label: PropTypes.string,
    disabledMessage: PropTypes.string,
    mode: PropTypes.string,
};

ColisLogistiquePhoto.defaultProps = {
    iconSize: 'small',
    disabledMessage: '',
    mode: 'icon',
};

export default ColisLogistiquePhoto;